import { render, staticRenderFns } from "./ClosingPartialDelivery.vue?vue&type=template&id=61e6dc8f&"
import script from "./ClosingPartialDelivery.vue?vue&type=script&lang=js&"
export * from "./ClosingPartialDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports